import { BlogSection } from '@/types/blog';

// This section is now handled by the FAQ accordion system
// The FAQ data is located in src/data/faq/mythos-nische-faq.ts
export const faq: BlogSection = {
  id: 'faq',
  title: '',
  content: ''
};
